const convertTimestamp = timestamp => {
  try {
    return timestamp.replace(/T/g, ' ').replace(/Z/g, '')
  } catch(error) {
    return null
  }
}

export default convertTimestamp



// WEBPACK FOOTER //
// ./src/utility/convertTimestampForMapbox.js